export const UPDATE_SEARCH_SUGGESTIONS = 'Web.TemplatesInterface.v1_0.Touch.ChromeTemplateInterface.UpdateSearchSuggestionsMethod';
export const UPDATE_SEARCH_BOX = 'UPDATE_SEARCH_BOX';
export const UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM';
export const REMOVE_SEARCH_SUGGESTIONS = 'REMOVE_SEARCH_SUGGESTIONS';
